import { tWithKeyAttr as t } from "../../i18nHelper";
import React from 'react';
import styles from './riskStatusBar.module.css';
import warningIcon from '../../images/warning_icom.svg';

interface RiskStatusBarProps {
    percentage: number; // 0 to 100
}

const RiskStatusBar: React.FC<RiskStatusBarProps> = ({ percentage }) => {

    const getRiskColor = (percentage: number): string => {
        if (percentage < 50) {
            // Yellow to Orange
            const r = 255;
            const g = Math.round(255 - (percentage / 50) * 165); // 255 → 90
            const b = 0;
            return `rgb(${r},${g},${b})`;
        } else {
            // Orange to Red
            const r = 255;
            const g = Math.round(90 - ((percentage - 50) / 50) * 90); // 90 → 0
            const b = 0;
            return `rgb(${r},${Math.max(g, 0)},${b})`;
        }
    };
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                    <img alt={t('RISK_STATUS')} src={warningIcon} className={styles.arrow}/>
                    <span className={styles.title}>{t('RISK_STATUS')}</span>
            </div>

            <div dir='ltr' className={styles.barContainer}>
                <div
                    className={styles.filled}
                    style={{ width: `${percentage}%` }}
                />
            </div>

            <div dir='ltr' className={styles.labels}>
                <span>{"0%"}{t('WITHOUT_RISK')}</span>
                <span>{t('HIGH_RISK_100_PERCENT')}</span>
            </div>

            <div className={styles.summary} style={{ backgroundColor: getRiskColor(percentage) }}>
                {t('RISK')} {percentage > 50 ? t('HIGH') : t('LOW')} - {percentage}%
            </div>
        </div>
    );
};

export default RiskStatusBar;
